// Minimalize menu when screen is less than 768px
$(() => {
    // Full height of sidebar
    function fix_height() {
        const heightWithoutNavbar = window.innerHeight - 61
        $('.sidebard-panel,#page-wrapper').css('min-height', `${heightWithoutNavbar}px`)
    }
    $(window).on('load resize scroll', () => {
        if (!$('body').hasClass('body-small')) {
            // fix_height();
        }
    })
    $(window).on('load resize', function () {
        if ($(this).width() < 768) {
            $('body').addClass('body-small')
        } else {
            $('body').removeClass('body-small')
        }
    })
    setTimeout(() => {
        $('#side-menu').metisMenu()
        // fix_height();
    }, 2000) // 与 angular 生命周期不同 后期迁移至同一个菜单上
})



// WEBPACK FOOTER //
// ./src/common/external.js